export default "__VITE_ASSET__C4QNzL4P__"